export const buildRegisterCauseQueries = (search) => ({
  // Hazard search must not refetch/reset the selected equipment list.
  assetQuery: { params: { filter: search.filter } },
  situationQuery: {
    params: {
      danger_category: search.danger_category,
      danger_cause: search.danger_cause,
      globalDBFilter: search.globalDBFilter?.trim() || "",
    },
  },
  situationEnabled: Boolean(
    search.globalDBFilter?.trim() || (search.danger_category && search.danger_cause)
  ),
});
